<script>
  export let delRel = [];
  export let questions = [];
  export let recalculateDelRel;
  
  // Helper function to get question label by index
  function getQuestionLabel(index) {
    if (!questions || !questions[index]) return `Q${index}`;
    const label = questions[index].label || `Question ${index}`;
    // Truncate long labels
    return label.length > 30 ? label.substring(0, 30) + '...' : label;
  }
  
  // Helper function to format dependencies
  function formatDependencies(relationships) {
    if (relationships === null) {
      return null;
    }
    
    if (typeof relationships === 'number') {
      return [relationships];
    }
    
    if (Array.isArray(relationships)) {
      return relationships;
    }
    
    return null;
  }
</script>

<div class="simple-delrel-display">
  <div class="delrel-header">
    <h4>Question Dependencies</h4>
    <button class="btn btn-small" on:click={recalculateDelRel}>
      Refresh
    </button>
  </div>
  
  {#if delRel && delRel.length > 0}
    <div class="delrel-list">
      {#each delRel as [questionIndex, relationships]}
        {@const dependencies = formatDependencies(relationships)}
        <div class="delrel-item" class:has-deps={dependencies !== null}>
          <div class="question-info">
            <span class="question-index">Q{questionIndex}</span>
            <span class="question-label">{getQuestionLabel(questionIndex)}</span>
          </div>
          
          <div class="dependencies">
            {#if dependencies === null}
              <span class="no-deps">No dependencies</span>
            {:else}
              <span class="has-deps-text">Affects:</span>
              {#each dependencies as depIndex, i}
                <span class="dep-item">Q{depIndex}</span>{#if i < dependencies.length - 1}, {/if}
              {/each}
            {/if}
          </div>
        </div>
      {/each}
    </div>
  {:else}
    <div class="no-questions">
      <p>No questions to analyze</p>
    </div>
  {/if}
</div>

<style lang="scss">
  .simple-delrel-display {
    margin-bottom: 15px;
    
    .delrel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      
      h4 {
        margin: 0;
        font-size: 0.85rem;
        font-weight: bold;
      }
    }
  }
  
  .delrel-list {
    max-height: 200px;
    overflow-y: auto;
  }
  
  .delrel-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 8px;
    margin-bottom: 2px;
    border-radius: 3px;
    background: #f9fafb;
    border-left: 3px solid #e5e7eb;
    
    &.has-deps {
      background: #fef3c7;
      border-left-color: #f59e0b;
    }
    
    .question-info {
      display: flex;
      align-items: center;
      gap: 6px;
      flex: 1;
      
      .question-index {
        background: #374151;
        color: white;
        padding: 1px 4px;
        border-radius: 2px;
        font-size: 0.65rem;
        font-weight: bold;
        min-width: 20px;
        text-align: center;
      }
      
      .question-label {
        font-size: 0.7rem;
        color: #374151;
      }
    }
    
    .dependencies {
      font-size: 0.65rem;
      text-align: right;
      
      .no-deps {
        color: #6b7280;
        font-style: italic;
      }
      
      .has-deps-text {
        color: #92400e;
        font-weight: bold;
        margin-right: 4px;
      }
      
      .dep-item {
        background: #92400e;
        color: #fbbf24;
        padding: 1px 3px;
        border-radius: 2px;
        font-weight: bold;
        margin-left: 2px;
      }
    }
  }
  
  .no-questions {
    text-align: center;
    padding: 15px;
    color: #6b7280;
    font-size: 0.75rem;
    font-style: italic;
  }
  
  .btn {
    padding: 3px 6px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 0.65rem;
    font-weight: bold;
    background: #10b981;
    color: white;
    
    &:hover {
      background: #059669;
    }
    
    &.btn-small {
      padding: 2px 5px;
      font-size: 0.6rem;
    }
  }
</style>